import setWaitingHallUpdate from './setWaitingHallUpdate';
import cartClient from '%evp_ticket_frontend/js/redux/currentCart/service/CartClient';
import selectCartItemsBySeatingHash from '%evp_ticket_frontend/js/redux/currentCart/selectors/selectCartItemsBySeatingHash';
import { OBJECT_TYPE_GENERAL_ADMISSION } from '%paysera_seat_selection/js/seatSelection/config/constants';
import Translator from '%app/js/common/services/translator';
import { setCart } from '%evp_ticket_frontend/js/redux/currentCart';
import { seatingDiscarded } from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/actions';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';

function discardSeating(seating) {
    return async (dispatch, getState) => {
        dispatch(setWaitingHallUpdate(true));
        const cartItem = selectCartItemsBySeatingHash(getState(), seating.hash);
        try {
            const cart = await cartClient.discardReservation({ id: cartItem.order_detail_id });
            dispatch(seatingDiscarded({
                type: seating.objectType,
                hash: seating.hash,
                seats_used: seating.objectType === OBJECT_TYPE_GENERAL_ADMISSION
                    ? seating.seatsUsed - cartItem.tickets_count
                    : 1,
            }));
            dispatch(setCart(cart));
        } catch (error) {
            if (error.response && error.response.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans('seat_selection_integration.error_notification.discard_failed'),
                }));
            }
            throw error;
        } finally {
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default discardSeating;
